import { CONTACT, NAV_LINKS } from "@/data/content";
import { scrollToSection } from "./Header";

const Footer = () => (
  <footer
    data-testid="site-footer"
    className="border-t border-white/10 bg-[#06090F]"
  >
    <div className="mx-auto max-w-7xl px-4 py-16 sm:px-8 lg:px-16">
      <div className="grid grid-cols-1 gap-12 md:grid-cols-3">
        <div>
          <img
            src="/logo-light.png"
            alt="Jeet Advisory Services"
            className="h-14 w-auto"
          />
          <p className="mt-6 max-w-xs font-mono2 text-[10px] uppercase leading-loose tracking-[0.2em] text-slate-500">
            Capital Advisory · Structured Finance · Private Credit · Project
            Finance
          </p>
        </div>

        <nav aria-label="Footer">
          <p className="font-mono2 text-[10px] uppercase tracking-[0.3em] text-slate-600">
            Navigate
          </p>
          <ul className="mt-5 grid grid-cols-2 gap-x-8 gap-y-3">
            {NAV_LINKS.map((link) => (
              <li key={link.id}>
                <button
                  data-testid={`footer-link-${link.id}`}
                  onClick={() => scrollToSection(link.id)}
                  className="text-sm font-light text-slate-400 transition-colors duration-300 hover:text-[#F26122]"
                >
                  {link.label}
                </button>
              </li>
            ))}
          </ul>
        </nav>

        <div>
          <p className="font-mono2 text-[10px] uppercase tracking-[0.3em] text-slate-600">
            Contact
          </p>
          <ul className="mt-5 space-y-3 text-sm font-light text-slate-400">
            <li>
              <a
                data-testid="footer-email-link"
                href={`mailto:${CONTACT.email}`}
                className="transition-colors duration-300 hover:text-[#F26122]"
              >
                {CONTACT.email}
              </a>
            </li>
            <li>
              <a
                data-testid="footer-whatsapp-link"
                href={CONTACT.whatsapp}
                target="_blank"
                rel="noopener noreferrer"
                className="transition-colors duration-300 hover:text-[#F26122]"
              >
                WhatsApp: {CONTACT.phoneDisplay}
              </a>
            </li>
            <li>
              <a
                data-testid="footer-linkedin-link"
                href={CONTACT.linkedin}
                target="_blank"
                rel="noopener noreferrer"
                className="transition-colors duration-300 hover:text-[#F26122]"
              >
                LinkedIn: {CONTACT.linkedinName}
              </a>
            </li>
          </ul>
        </div>
      </div>

      <div className="pointer-events-none mt-16 select-none overflow-hidden" aria-hidden="true">
        <p
          data-testid="footer-wordmark"
          className="ghost-numeral whitespace-nowrap text-center text-[clamp(2.5rem,9vw,8.5rem)] leading-none"
        >
          JEET ADVISORY
        </p>
      </div>

      <div className="hairline-gold mt-14 opacity-30" aria-hidden="true" />

      <div className="mt-10 space-y-4">
        <p
          data-testid="footer-disclaimer-1"
          className="max-w-4xl text-xs font-light leading-relaxed text-slate-600"
        >
          Jeet Advisory Services acts as a financial advisory and
          capital-arranging intermediary. Financing is subject to the
          independent assessment, due diligence, commercial terms and approval
          of the respective capital provider.
        </p>
        <p
          data-testid="footer-disclaimer-2"
          className="max-w-4xl text-xs font-light leading-relaxed text-slate-600"
        >
          Information provided on this website is for general informational
          purposes and does not constitute a commitment to provide financing.
        </p>
        <p className="pt-4 font-mono2 text-[10px] uppercase tracking-[0.25em] text-slate-700">
          © 2026 Jeet Advisory Services. All rights reserved.
        </p>
      </div>
    </div>
  </footer>
);

export default Footer;
